import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .modal': {
      '&-title': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
        },
        '&-text': {
          flexGrow: 1,
        },
        '&-btn-close': {
          marginRight: theme.spacing((3 / 2) * -1),
        },
      },
      '&-subtitle': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
          padding: theme.spacing(0, 1, 1),
        },
      },
      '&-content': {
        '&-container': {
          width: '100%',
          position: 'relative',
          height: theme.spacing(40),
          maxHeight: '70vh',
          padding: 0,
          display: 'flex',
          alignItems: 'flex-start',
        },
      },
    },
    '& .btn-close': {
      marginRight: 'auto',
    },
  },
  paper: {
    width: '100%',
  },
}));

export default styles;
